import React from "react";
import { useEffect, useState } from "react";
import { Line} from "react-chartjs-2";
import { useTenantParams } from "../../../../customhooks/tenantparamlookup"; //CustomHook
import { CircularProgress ,Grid, Typography} from "@material-ui/core";
import { store } from "../../../../helpers/store";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useTranslation } from "react-i18next";


const useStyle = makeStyles((theme) => ({
  spinner:{
    alignItems: "center", display: "flex", justifyContent: "center"
  },
  spinner2:{
    justifyContent: "center", position: "fixed", top: "50%" 
  },
  error:{
    align:"center", fontSize:"larger", fontWeight:"bold",
    color:  theme.palette.ePrimary?.base,
  },
  errorIcon:{
    width :"-webkit-fill-available",
    height :"6vh",
    color:  theme.palette.eLight?.base,
  },
}));


// This Code is for Line,Bar,Line with Bar and Stacked Bar with Line Chart
export default function ChartTest(props) {
  const classes = useStyle()
  const theme = useTheme();
  const propsApiData = props.data;
  const propsData = props.compareData;
  let charttitle = props.labelReady ? props?.labels("E_CO2_EMISSION_REPORT_TITLE") : '';

  //Using useTenantParams Custom Hook........................
  let [chartlabels] = useTenantParams(["E_CO2_EMISSION_UNITS"]);
  
  let [chartypes] = useTenantParams(["USAGE_CHART_TYPE"]);
  let [appColor] = useTenantParams(
    [
      "PRIMARY_COLOR_2",
    ],
    {}
  );

  //Chart Datasets......
  //Based on data we need change array length Ex: ["kwh", "temp", "ele"],[appColor.quaternaryColor, appColor.secondaryColor, appColor.primaryColor] etc....
  let stacked = false; //Stacked True means we will get Stacked Chart,if False we will get Bar chart
  let backgroundColors = [theme.palette.ePrimary?.base];
  let chartOrders = [1];
  let colorFills = [true]; // color fills mostly used for Line Chart [true, false, true]
  let borderColors = [theme.palette.ePrimary?.base];
  // Chart Option........
  let titles = {
    display: false,
    text: charttitle,
    fontSize: "large",
  };


  let tooltip = {
    enabled: true,
    usePointStyle: true,
    position: "average",
    mode: "nearest",
    intersect: false,
    backgroundColor: theme.palette.whiteColor.main,
    bodyColor: theme.palette.eDark?.base,
    bodyFontColor: theme.palette.eDark?.base,
    padding: 10,
    borderColor: theme.palette.eLight?.base,
    borderWidth: 1,
    cornerRadius: 2,
    boxWidth: 6,
    boxHeight: 6,
    callbacks: {
        title: () => null,
        label: function (context) {
            return [context.label, Math.round(context.parsed.y)+' '+ chartlabels]
        }
    },
    displayColors: true,
  };
  //Chart  States.....
  const [dataChart, setDataChart] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const [noData,setNoData]=useState(false)

  //Error Handling
  const [errorData, setErrorData] = useState("");
  const {t:noRecordsAvailableLabels, ready: labelReady} = useTranslation("label-E_CO2_EMISSION_REPORT");
  
  const noRecordsAvailable = labelReady ? noRecordsAvailableLabels("E_NO_RECORDS") : '';
  const [error,setError] = useState(false);
  useEffect(() => {
    let usageQuantity = [];
    let usageLabels = [];
    let compareUsageQuantity = [];
    let compareusageLabels = [];
    if (backgroundColors[0] !== undefined) {
      if (propsApiData !== "" || propsApiData !== noRecordsAvailable) {
        store.getState().snackbar=true
        try {
          propsApiData.forEach((item) => {
            usageQuantity.push(item.quantity);
            usageLabels.push(item.intervalShortName);
          });
          setError(false);
        } catch (err) {
          setError(true);
        }
        store.getState().snackbar=false

      }
      if (propsData !== "" || propsData !== noRecordsAvailable) {
        store.getState().snackbar=true
        try {
          propsData.forEach((item) => {
            compareUsageQuantity.push(item.quantity);
            compareusageLabels.push(item.intervalShortName);
          });
          setError(false);
        } catch (err) {
          setError(true);
        }
        store.getState().snackbar=false
      }
      let finalChartData = [usageQuantity]; //Here we need to add data based on requirement...EX:[usageQuantity, temparature, usageEle]
      let finalChartDataset = [];
      let finalCompareData = [compareUsageQuantity];
      store.getState().snackbar=true
      if (props.data && props?.compareData?.length > 0) {
        let usagePoints = [];
        let usageComparePoints = [];
        let chartDataset = {};
        usagePoints.push(finalChartData[finalChartData.length-1]);
        usageComparePoints.push(finalCompareData[finalChartData.length-1]);
        chartDataset = {
          fill: colorFills[0],
          lineTension: 0.6,
          type: chartypes[0],    
          borderColor: borderColors[0],
          datasets: [
            { data: usagePoints[0], backgroundColor: theme.palette.ePrimary?.base },
            {
              data: usageComparePoints[0],
              backgroundColor: theme.palette.ePrimary?.base,
            },
          ],
          borderWidth: 3,
          order: chartOrders[0],
          labels: usageLabels,
        };
        finalChartDataset.push(chartDataset);
      } else {
         for (let i = 0; i < finalChartData.length; i++) {
          let chartDataset = {
            fill: colorFills[i],
            type: chartypes[i],
            borderColor: borderColors[i],
            borderWidth: 3,
            datasets: [
              {
                label: chartlabels,
                data: finalChartData[i],               
                backgroundColor: theme.palette.ePastelColor2?.base,
                tension: 0.4,
                fill: true,
              },
            ],
            order: chartOrders[i],
            labels: usageLabels,
          };
          finalChartDataset.push(chartDataset);
        }
      }
      store.getState().snackbar=false

      let filteredData = finalChartDataset?.[0]?.datasets?.[0]?.data.filter((item)=>item!=='0');
      if(filteredData.length === 0 ){
        setNoData(true)
      }else {
        setNoData(false)
      }
      setErrorData(propsApiData);
      setDataChart({
        datasets: finalChartDataset[0],
      });
      setChartOptions({
        title: titles,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              color: theme.palette.ePrimary?.base
          },
          },
          tooltip: tooltip,
      },
        scales: {
          x: 
            {
              stacked: stacked,
              ticks: {
                color: theme.palette.ePrimary?.base,
              },

              grid: {
                display: false,
              },
            },
          
          y: 
            {
              stacked: stacked,
              grid: {
                display: true,
              },             
              ticks: {
                beginAtZero: true,
                color: theme.palette.ePrimary?.base,
              },
            },
          
        },
      });
    }
  }, [props.compareData, props.data, appColor]);

  const datasetKeyProvider = () => {
    return btoa(Math.random()).substring(0, 12);
  };



  return (
    <div >
      {store.getState().snackbar ?(
          <Grid align="center">
            <CircularProgress disableShrink />
          </Grid>
        ):(<>
          {dataChart.datasets ?       
        noData === false ? (       
          <Line
            data={dataChart.datasets}
            options={chartOptions}
            datasetKeyProvider={datasetKeyProvider}
            height={props.height}
            width={props.width}
          /> 
        ):(<><ReportProblemOutlinedIcon className={classes.errorIcon} />
          <Grid justify="center" container>
            <Grid item>
              <Typography className={classes.error}>{noRecordsAvailable}</Typography>
            </Grid>
          </Grid></>
        )
      : error ? (<><ReportProblemOutlinedIcon className={classes.errorIcon} />
          <Grid justify="center" container>
            <Grid item>
            <Typography className={classes.error}>{errorData}</Typography>
            </Grid>
          </Grid>
        </>
      ) : (<div></div>)}
        </>)} 
    </div>
  );
}